module.exports = __webpack_public_path__ + "static/media/kala.68865eab.jpg";